import { atomWithStorage } from 'jotai/utils';
import { sidebarState } from '@/state/sidebar.state';
import { setAtomValue } from '@/shared/jotai';

const STORAGE_KEY = 'savvy-navbar-closed-by-user';

export const navbarClosedByUserState = atomWithStorage<Record<number, boolean>>(
  STORAGE_KEY,
  {},
);

export const clearNavbarClosedStateOnLogout = (): void => {
  setAtomValue(navbarClosedByUserState, {});
  setAtomValue(sidebarState, null);
};
